module.exports = __webpack_public_path__ + "img/red.b8998f90.png";